import { Component, Directive, NgModule } from '@angular/core';

export abstract class PgNotificationChild {}

@Directive({
  selector:
    'pg-notification-title, [pgNotificationTitle], grit-notification-title, [gritNotificationTitle]',
  providers: [
    {
      provide: PgNotificationChild,
      useExisting: PgNotificationTitleDirective,
    },
  ],
})
export class PgNotificationTitleDirective {}

@Directive({
  selector:
    'pg-notification-body, [pgNotificationBody], grit-notification-body, [gritNotificationBody]',
  providers: [
    {
      provide: PgNotificationChild,
      useExisting: PgNotificationBodyDirective,
    },
  ],
})
export class PgNotificationBodyDirective {}

@Directive({
  selector:
    'pg-notification-action, [pgNotificationAction], grit-notification-action, [gritNotificationAction]',
  providers: [
    {
      provide: PgNotificationChild,
      useExisting: PgNotificationActionDirective,
    },
  ],
})
export class PgNotificationActionDirective {}

@NgModule({
  declarations: [
    PgNotificationTitleDirective,
    PgNotificationBodyDirective,
    PgNotificationActionDirective,
  ],
  exports: [
    PgNotificationTitleDirective,
    PgNotificationBodyDirective,
    PgNotificationActionDirective,
  ],
})
export class PgNotificationProjectionModule {}
